import adProductsIcon from "./ad-products-icon.svg";

export { adProductsIcon };
